"use client"

import * as React from "react"
import { useAppStore } from "@exxatdesignux/product-framework/app-store"

/** Subscribe to zustand persist hydration without effect-driven `setState`. */
export function usePersistHydrated(): boolean {
  React.useEffect(() => {
    if (!useAppStore.persist.hasHydrated()) {
      void useAppStore.persist.rehydrate()
    }
  }, [])

  return React.useSyncExternalStore(
    useAppStore.persist.onFinishHydration,
    () => useAppStore.persist.hasHydrated(),
    () => false,
  )
}
